import type { ComponentPropsWithRef } from "react";
import { cn, getInitials } from "@/lib/utils";
import { brandFillClass } from "./fill-variants";

export type AvatarProps = Omit<ComponentPropsWithRef<"div">, "children"> & {
  avatarLabel: string;
  src?: string;
  alt?: string;
  name?: string;
  size?: "sm" | "md" | "lg" | "xl";
};

const sizeClasses = {
  sm: "w-8 h-8 text-xs",
  md: "w-10 h-10 text-sm",
  lg: "w-12 h-12 text-base",
  xl: "w-16 h-16 text-lg",
};

export function Avatar({
  avatarLabel,
  src,
  alt,
  name,
  size = "md",
  className,
  ...rest
}: AvatarProps) {
  const initials = name ? getInitials(name) : "?";

  if (src) {
    return (
      <img
        src={src}
        alt={alt || name || avatarLabel}
        className={cn(
          "rounded-full object-cover ring-2 ring-surface-0",
          sizeClasses[size],
          className,
        )}
      />
    );
  }

  return (
    <div
      className={cn(
        "flex items-center justify-center rounded-full font-semibold",
        brandFillClass("primary"),
        sizeClasses[size],
        className,
      )}
      aria-label={name || avatarLabel}
      {...rest}
    >
      {initials}
    </div>
  );
}
